import request from '@/utils/request'

export function GetThemeData() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetThemeHomeData',
        method: 'post',
        data: {}
    })
}




// WEBPACK FOOTER //
// ./src/api/Theme.js